import { Box, Button, Card, Divider, Modal, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles(theme => ({
  editorCard: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '92vw',
    maxWidth: 1400,
    height: '88vh',
    maxHeight: '88vh',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  header: {
    padding: theme.spacing(2, 3),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  body: {
    flex: 1,
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: theme.spacing(3),
    backgroundColor: theme.palette.grey[50],
  },
  footer: {
    padding: theme.spacing(2, 3),
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
  },
}));

export const ImportTemplateEditor = props => {
  const { actions, children, closeLabel, disableBackdropClose, disableEnforceFocus, onClose, open, secondaryText, title } = props;
  const classes = useStyles();

  const handleClose = (event, reason) => {
    if (disableBackdropClose && reason === 'backdropClick') return;

    onClose(event, reason);
  };

  return (
    <Modal open={open} onClose={handleClose} disableEnforceFocus={disableEnforceFocus} aria-labelledby="import-template-editor-title">
      <Card className={classes.editorCard}>
        <Box className={classes.header}>
          <Box>
            <Typography id="import-template-editor-title" variant="h5">
              {title}
            </Typography>
            {secondaryText && (
              <Typography variant="body2" color="textSecondary">
                {secondaryText}
              </Typography>
            )}
          </Box>
          <Button onClick={onClose}>{closeLabel}</Button>
        </Box>

        <Divider />

        <Box className={classes.body}>
          {children}
        </Box>

        <Divider />

        {actions && (
          <Box className={classes.footer}>
            {actions}
          </Box>
        )}
      </Card>
    </Modal>
  );
};

ImportTemplateEditor.defaultProps = {
  actions: null,
  closeLabel: 'Close',
  disableBackdropClose: true,
  disableEnforceFocus: false,
  secondaryText: null,
};

ImportTemplateEditor.propTypes = {
  actions: PropTypes.node,
  children: PropTypes.node.isRequired,
  closeLabel: PropTypes.string,
  disableBackdropClose: PropTypes.bool,
  // Lets the MUI v5 menus and dialogs inside the editor keep focus; this v4 Modal's focus trap fights theirs
  disableEnforceFocus: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  secondaryText: PropTypes.node,
  title: PropTypes.node.isRequired,
};
